import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import Modal from "../../components/shared/Modal/Modal";
import { useTranslation } from "react-i18next";
import { ServiceNextProject } from "../../services/ServiceNextProject";
import { Loading } from "../../components/shared";
import Selector, { SelectorType } from "../../components/shared/Selector/Selector";

type Props = {
  show: boolean,
  setShow: Dispatch<SetStateAction<boolean>>,
  projectId: string | null,
  onSuccess: (response: any) => void,
  onError: (error: any) => void,
}

const ExportNextProjectModal: FC<Props> = ({ show, setShow, projectId, onSuccess, onError }) => {
  const [t] = useTranslation('projects');
  const [options, setOptions] = useState<SelectorType[]>([]);
  const [selectedParentProject, setSelectedParentProject] = useState<SelectorType>(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (show) {
      (async () => {
        setLoading(true);
        try {
          const projects = await ServiceNextProject.listProjects();
          setOptions(
            projects.map((p: any) => ({
              label: `${p.projectno} ${p.name}`,
              value: String(p.id),
            }))
          );
        } catch (error) {
          // ignore
        }
        setLoading(false);
      })();
    }
  }, [show]);

  const handleExport = async () => {
    if (!projectId || !selectedParentProject) return;
    setExporting(true);
    try {
      const response = await ServiceNextProject.exportProject(projectId, Number(selectedParentProject.value));
      onSuccess(response);
      setShow(false);
    } catch (error) {
      onError(error);
    }
    setExporting(false);
  };

  return (
    <Modal
      title={t('exportNextProjectModal.headline', 'Skicka till Next Project')}
      show={show}
      setShow={setShow}
      buttonInfo={{
        label: t('exportNextProjectModal.button.send', 'Skicka'),
        action: handleExport,
        disabled: !selectedParentProject || exporting,
        loaderShow: exporting,
      }}
    >
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Loading type="inline" color="#ff5e15" size="30px" />
        </div>
      ) : (
        <Selector
          label={t('exportNextProjectModal.parentProjectLabel', 'Placering')}
          options={options}
          value={selectedParentProject}
          onChange={(value) => setSelectedParentProject(value)}
          placeholder={t('exportNextProjectModal.selectParentProject', 'Välj överordnat projekt')}
          isSearchable
        />
      )}
    </Modal>
  );
};

export default ExportNextProjectModal;
